import type { Translation } from 'Store'
import getTranslation from 'Util/getTranslation'
import { Box, Button, ButtonGroup, styled, useTheme } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { t } from 'ttag'

interface TranslatedFieldProps {
  translations: Translation[]
  field: keyof Translation
}

const StyledTranslationButton = styled(Button)(({ theme }) => ({
  borderRadius: 4,
  padding: theme.spacing(1, 1.5),
  color: theme.palette.text.secondary,
  textTransform: 'uppercase'
}))

function TranslatedField({ translations, field }: Readonly<TranslatedFieldProps>) {
  const [lang, setLang] = useState<string>('fi')
  const theme = useTheme()
  const languageOptions = translations.map(translation => translation.locale.toLowerCase())
  return (
    <Box pr={2} display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="body2">{getTranslation(translations, lang)[field]}</Typography>
      <ButtonGroup
        variant="text"
        sx={{
          '.MuiButtonGroup-grouped:not(:last-of-type)': {
            borderColor: theme.palette.action.selected
          }
        }}
        aria-label={t`Language selection buttons`}
      >
        {languageOptions.map(option => {
          return (
            <StyledTranslationButton
              key={option}
              size="small"
              onClick={() => setLang(option)}
              sx={{
                fontWeight: option === lang ? '700' : '600',
                backgroundColor: option === lang ? theme.palette.action.selected : 'transparent'
              }}
            >
              {option}
            </StyledTranslationButton>
          )
        })}
      </ButtonGroup>
    </Box>
  )
}

export default TranslatedField
